import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { apiErrorsToFormik } from 'utils/errors';
import useApp from 'reducers/hooks/useApp';
import Loader from 'sharedComponents/Loader';
import Alert from 'sharedComponents/Alert';
import { initialValues, validationSchema } from 'forms/updatePasswordForm';
import Title from '../Title';
import ResetPasswordForm from './components/ResetPasswordForm';
import useStyles from './useStyles';

const ResetPassword = props => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { onBack } = props;
  const { updatePassword, loading } = useApp();
  const [isShowAlert, setShowAlert] = useState(false);

  const handleCloseAlert = () => {
    setShowAlert(false);
  };

  const handleSubmit = async (values, { setErrors, setValues }) => {
    try {
      await updatePassword(values);
      setValues(initialValues, false);
      setShowAlert(true);
    } catch (error) {
      const { fullMessages } = apiErrorsToFormik(error);
      setErrors({ currentPassword: fullMessages });
    }
  };

  const title = t('components.LoanOfficerSettings.title.resetPassword');
  const alertSuccessText = t('components.LoanOfficerSettings.ResetPasswordForm.alert.success');

  return (
    <div className={classes.container}>
      <Title text={title} onBack={onBack} />
      <ResetPasswordForm onSubmit={handleSubmit} initialValues={initialValues} validationSchema={validationSchema} />
      {loading && <Loader fullFill />}
      <Alert text={alertSuccessText} open={isShowAlert} handleClose={handleCloseAlert} />
    </div>
  );
};

ResetPassword.propTypes = {
  onBack: PropTypes.func.isRequired,
};

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/ResetPassword/ResetPassword.js